import { render, staticRenderFns } from "./SearchFeedSection.vue?vue&type=template&id=0ddb8e9e&scoped=true"
import script from "./SearchFeedSection.vue?vue&type=script&lang=js"
export * from "./SearchFeedSection.vue?vue&type=script&lang=js"
import style0 from "./SearchFeedSection.vue?vue&type=style&index=0&id=0ddb8e9e&prod&lang=css"
import style1 from "./SearchFeedSection.vue?vue&type=style&index=1&id=0ddb8e9e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ddb8e9e",
  null
  
)

export default component.exports